<div class="notification__image-wrapper">
  @if (!flagged) {
    <pp-icon class="notification__image" [ppSrc]="EIconPath.ICON_ACTIVITIES_RED_FLAG_14" ppClass="setSize14" ppColor="grey-500"/>
  }
  @if (flagged) {
    <img class="notification__image" [src]="EIconPath.ICON_ACTIVITIES_RED_FLAG_ACTIVATED_14"/>
  }
</div>

<span>
  {{ (flagged ? 'point_flagged' : 'point_unflagged') | ppTranslate }}
</span>
